import React from 'react';
import { SkeletonBlock } from '@one-thd/sui-atomic-components';

// Placeholders shown by FulfillmentDetailsDrawer while its orderDetails query is in flight. Each
// mirrors the layout of the section it stands in for (status + 3-step tracker, address block with
// icon gutter, line-item rows with a thumbnail, sticky-footer button) so the drawer doesn't jump
// when the real content arrives.

export const FulfillmentTitleSkeleton: React.FC = () => (
  <div data-testid="fulfillment-drawer-title-skeleton" className="sui-w-64">
    <SkeletonBlock height={6} width="100%" />
  </div>
);

export const FulfillmentStatusSkeleton: React.FC = () => (
  <div data-testid="fulfillment-drawer-loading" className="sui-mt-4 sui-flex sui-flex-col sui-gap-3">
    <SkeletonBlock height={4} width="35%" />
    <SkeletonBlock height={6} width="75%" />
    <div className="sui-mt-2 sui-flex sui-flex-row sui-items-start sui-justify-between sui-gap-4">
      {[0, 1, 2].map((step) => (
        <div key={step} className="sui-flex sui-flex-1 sui-flex-col sui-gap-2">
          <SkeletonBlock height={8} width="2rem" />
          <SkeletonBlock height={4} width="80%" />
        </div>
      ))}
    </div>
  </div>
);

export const FulfillmentAddressSkeleton: React.FC = () => (
  <div className="sui-flex sui-flex-col sui-gap-4 sui-p-4" data-testid="fulfillment-drawer-address-skeleton">
    {[0, 1].map((block) => (
      <div key={block} className="sui-flex sui-flex-row sui-gap-4 sui-pl-2">
        <SkeletonBlock height={5} width="1.25rem" />
        <div className="sui-flex sui-flex-1 sui-flex-col sui-gap-2">
          <SkeletonBlock height={5} width="40%" />
          <SkeletonBlock height={4} width="65%" />
          <SkeletonBlock height={4} width="55%" />
        </div>
      </div>
    ))}
  </div>
);

export const FulfillmentLineItemsSkeleton: React.FC = () => (
  <div className="sui-flex sui-flex-col sui-gap-4" data-testid="fulfillment-drawer-line-items-skeleton">
    {[0, 1].map((row) => (
      <div key={row} className="sui-flex sui-flex-row sui-gap-4">
        <SkeletonBlock height={16} width="4rem" />
        <div className="sui-flex sui-flex-1 sui-flex-col sui-gap-2">
          <SkeletonBlock height={4} width="35%" />
          <SkeletonBlock height={4} width="80%" />
          <SkeletonBlock height={4} width="25%" />
        </div>
        <SkeletonBlock height={4} width="3rem" />
      </div>
    ))}
  </div>
);

export const FulfillmentActionsSkeleton: React.FC = () => <SkeletonBlock height={12} width="100%" />;
